import React, { useCallback } from "react";
import { Row, Col, Typography } from "antd";
import { useIntl } from "react-intl";

import Service from "./service";

function BcServices({
  rules,
  disabled,
  mainForm,
  initialServices,
  onSetCarryToFloor,
}) {
  const intl = useIntl();
  const { getFieldDecorator } = mainForm;

  const handleLiftChange = useCallback(
    (e) => {
      onSetCarryToFloor(e.target.checked);
    },
    [onSetCarryToFloor]
  );

  return (
    <div>
      {rules.carryToFloor && (
        <Row>
          <Service
            hideRow
            disabled={disabled}
            fieldName="carryToFloor"
            onChange={handleLiftChange}
            label={intl.formatMessage({
              id: "consignment.services.carryToFloor",
              defaultMessage: "Výnos do patra s pomocí příjemce",
            })}
            getFieldDecorator={getFieldDecorator}
            initialValue={initialServices && initialServices.carryToFloor}
          />
          {mainForm.getFieldValue("carryToFloor") && (
            <Col span={16} className="services-form-warning">
              <Typography.Text type="danger">
                {intl.formatMessage({
                  id: "consignment.services.carryToFloorInfo",
                  defaultMessage:
                    "V případě výnosu do patra je maximální hmotnost celé zásilky 80 kg a jednoho kusu 50 kg!",
                })}
              </Typography.Text>
            </Col>
          )}
        </Row>
      )}
      {rules.transportOldAppliance && (
        <Service
          disabled={disabled}
          label={intl.formatMessage({
            id: "consignment.services.transportOldAppliance",
            defaultMessage: "Odvoz starého spotřebiče",
          })}
          fieldName="transportOldAppliance"
          getFieldDecorator={getFieldDecorator}
          initialValue={
            initialServices && initialServices.transportOldAppliance
          }
        />
      )}
    </div>
  );
}

export default BcServices;
